import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { chapterMembershipOptions } from '@/module/Nomen/ChapterMembership/model/ChapterMembershipModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type ChapterMembershipSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function ChapterMembershipSelectControl<T extends FieldValues>(props: ChapterMembershipSelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(chapterMembershipOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
